import { render, staticRenderFns } from "./BlacklistNotice.vue?vue&type=template&id=4bdb04ee&scoped=true&"
import script from "./BlacklistNotice.vue?vue&type=script&lang=ts&"
export * from "./BlacklistNotice.vue?vue&type=script&lang=ts&"
import style0 from "./BlacklistNotice.vue?vue&type=style&index=0&id=4bdb04ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb04ee",
  null
  
)

export default component.exports